// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.list-lenders .cards-header[data-v-23634e23]{width:100%;margin-bottom:1rem}section.list-lenders .lenders[data-v-23634e23]{display:grid;width:100%;grid-gap:40px;gap:40px;grid-template-columns:repeat(1,1fr)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
